import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { IFeedbackReport } from '../../utils/interfaces/feedback-report';

@Component({
  selector: 'app-feedback-report-body',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (data()?.length) {
      @for (response of data(); track response.questionId) {
        <section class="feedback-card">
          <h3>{{ response.title }}</h3>
          <hr />

          @if (response.responsesOpens.length) {
            <div class="feedback-list">
              @for (item of response.responsesOpens; track $index) {
                <article class="feedback-item">
                  <div class="meta">
                    <span>{{ item.branchCode }} {{ item.branchName }}</span>
                    <span>{{ item.createdAt | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
                    <span>{{ item.device || '--' }}</span>
                    <span>{{ item.answerMainQuestion }}</span>
                  </div>
                  <p>{{ item.answerOpen || '--' }}</p>
                </article>
              }
            </div>
          } @else {
            <div class="empty">
              <p>Não há dados para exibir</p>
            </div>
          }
        </section>
      }
    } @else {
      <div class="empty">
        <p>Não há dados para exibir</p>
      </div>
    }
  `,
  styles: [
    `
      .feedback-card {
        margin-bottom: 2rem;
        break-inside: auto;
        page-break-inside: auto;
      }

      .feedback-card h3 {
        color: var(--s-red);
        font-size: 1.1rem;
        margin-bottom: 0.5rem;
      }

      .feedback-list {
        display: grid;
        gap: 0.75rem;
      }

      .feedback-item {
        background: var(--s-high-medium);
        border-radius: 0.5rem;
        break-inside: avoid;
        page-break-inside: avoid;
        padding: 0.75rem;
      }

      .meta {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-bottom: 0.5rem;
      }

      .meta span {
        background: white;
        border-radius: 999px;
        font-size: 0.8125rem;
        padding: 0.25rem 0.625rem;
      }

      .feedback-item p {
        margin: 0;
        white-space: pre-wrap;
        word-break: break-word;
      }
    `,
  ],
})
export class FeedbackReportBodyComponent {
  data = input<IFeedbackReport[] | null>(null);
}
